export const moduleWindow = {
    namespaced: true,
    state: {
        windowWidth: window.innerWidth,
        isLandscape: window.innerWidth > window.innerHeight,
        showBottomNav: true,
        isIOS : false
    },
    getters: {
        windowWidth(state) {
            return state.windowWidth;
        },
        isMobile(state) {
            return state.windowWidth <= 768; 
        },
        isTablet(state) {
            return state.windowWidth > 768 && state.windowWidth <= 1024; 
        },
        isDesktop(state) {
            return state.windowWidth > 1024; 
        },
        isLandscape(state) {
            return state.isLandscape;
        },
        showBottomNav(state) {
            return state.showBottomNav;
        },
        isIOS(state){
            return state.isIOS;
        }

    },
    mutations: {
        setWindowWidth(state, value) {
            state.windowWidth = value;
            state.isLandscape = value > window.innerHeight;
        },
        showBottomNav(state, value) {
            state.showBottomNav = value;
        },
        isIOS(state, value){
            state.isIOS = value;
        }
    },
    actions: {
        updateWindowWidth({ commit }) {
            commit('setWindowWidth', window.innerWidth);
        },
    },
    
}